module.exports = __webpack_public_path__ + "static/media/Het-Veer-weblogo.96f7deda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Het-Veer-weblogo.svg
// module id = 186
// module chunks = 0